export default __webpack_public_path__ + "static/media/footer-bottom.bc1d5ca5.svg";